module.exports = __webpack_public_path__ + "static/media/VISA.3f9cd9d5.png";